import {
  CustomerData,
  ClearCustomerErrorAction,
  FetchCustomerMeAction,
  FetchCustomerMeFailAction,
  FetchCustomerMeSuccessAction,
  FetchCustomersAction,
  FetchCustomersFailAction,
  FetchCustomersSuccessAction,
  SetCustomerErrorAction,
  UpdateCustomersAction,
  UpdateCustomersFailAction,
  UpdateCustomersSuccessAction,
} from '@funnels/types';

import { REDUX_STORE } from '@funnels/constants';

export function clearCustomerError(): ClearCustomerErrorAction {
  return { type: REDUX_STORE.CUSTOMERS.ACTION_TYPES.CLEAR_CUSTOMER_ERROR };
}

export function fetchCustomerMe(): FetchCustomerMeAction {
  return { type: REDUX_STORE.CUSTOMERS.ACTION_TYPES.FETCH_CUSTOMER_ME };
}

export function fetchCustomerMeFail(): FetchCustomerMeFailAction {
  return { type: REDUX_STORE.CUSTOMERS.ACTION_TYPES.FETCH_CUSTOMER_ME_FAIL };
}

export function fetchCustomerMeSuccess(customer: CustomerData): FetchCustomerMeSuccessAction {
  return { type: REDUX_STORE.CUSTOMERS.ACTION_TYPES.FETCH_CUSTOMER_ME_SUCCESS, customer };
}

export function fetchCustomers(customerIdList: string[]): FetchCustomersAction {
  return { type: REDUX_STORE.CUSTOMERS.ACTION_TYPES.FETCH_CUSTOMERS, customerIdList };
}

export function fetchCustomersFail(): FetchCustomersFailAction {
  return { type: REDUX_STORE.CUSTOMERS.ACTION_TYPES.FETCH_CUSTOMERS_FAIL };
}

export function fetchCustomersSuccess(customers: CustomerData[]): FetchCustomersSuccessAction {
  return { type: REDUX_STORE.CUSTOMERS.ACTION_TYPES.FETCH_CUSTOMERS_SUCCESS, customers };
}

export function setCustomerError(message: string = 'Unknown error'): SetCustomerErrorAction {
  return { type: REDUX_STORE.CUSTOMERS.ACTION_TYPES.SET_CUSTOMER_ERROR, message };
}

export function updateCustomers(customers: CustomerData[]): UpdateCustomersAction {
  return { type: REDUX_STORE.CUSTOMERS.ACTION_TYPES.UPDATE_CUSTOMERS, customers };
}

export function updateCustomersFail(): UpdateCustomersFailAction {
  return { type: REDUX_STORE.CUSTOMERS.ACTION_TYPES.UPDATE_CUSTOMERS_FAIL };
}

export function updateCustomersSuccess(): UpdateCustomersSuccessAction {
  return { type: REDUX_STORE.CUSTOMERS.ACTION_TYPES.UPDATE_CUSTOMERS_SUCCESS };
}
